import {createBarbaPage} from '../baseBarbaPage';
import { initLoginForm } from "../../modules/form-login/form-login";

export default  createBarbaPage({
    namespace: 'my-account',
    onEnter: function() {
        initLoginForm();
    },
    onEnterCompleted: function() {
        // The Transition has just finished.
    },
    onLeave: function() {
        // A new Transition toward a new page has just started.

    },
    onLeaveCompleted: function() {
        // The Container has just been removed from the DOM.
    }
});

